import React from 'react';
import { Link } from 'react-router-dom'
import { Footer } from '../Common/Footer';
import { connect } from 'react-redux';
import { buyerRequest } from '../../Action/buyerRequest';
import { withRouter } from 'react-router-dom';
import ProductsUpload from '../../Models/ProductsUpload';
import Products from '../../Models/Products';
import SimpleReactValidator from 'simple-react-validator';
import { Header } from '../Common';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '55%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
class PostRequestBuyer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            modalIsOpen: false,
            title: '',
            description: '',
            category: 258,
            subCategory: 259,
            budgetsingle: '',
            date: '',
            categories: [],
            subCategories: [],
            budget: [],
            cat_name: '',
            sub_cat_name: '',
            budget_name: ''
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.post = this.post.bind(this);
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
        this.getCategories();
        this.getBudgetList();
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }

    getBudgetList() {
        Products.getBudget().then(res => {
            this.setState({ budget: res.data.message })
        })
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleChange(e) {
        this.setState({
            category: this.refs.category.value
        })
        ProductsUpload.getSubCategory(e.target.value).then(res => {
            this.setState({
                subCategories: res.data.category_sub
            })
        })
    }

    handleChangesubcat(e) {
        this.setState({
            subCategory: this.refs.subCategory.value
        })
    }

    handleChangebudget(e) {
        this.setState({
            budgetsingle: this.refs.budget.value
        })
    }
    //Request confirmation modal
    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        console.log("after open modal");
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    updateChange(e) {
        this.handleChangebudget();
        this.setState({
            budgets: e.target.value,
            budgetValue: e.target.key
        })
    }

    post(e) {
        document.getElementById("final_post").disabled = true;
        e.preventDefault();
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        let data = {
            buyer_id: logged_user.id,
            title: this.state.title,
            application_date: this.state.date,
            content: this.state.description,
            // category: this.refs.category.value,
            // sub_category: this.refs.subCategory.value,
            category: 258,
            sub_category: 259,
            budget: this.refs.budget.value,
        }
        this.props.buyerRequest(data, this.props.history);
    }

    handleSubmit(e) {
        e.preventDefault();
        let data = {
            category: this.state.category,
            subcategory: this.state.subCategory,
            budget: this.state.budgetsingle,
        }
        ProductsUpload.getNames(data).then(res => {
            this.setState({
                cat_name: res.data.cat,
                sub_cat_name: res.data.sub_cat,
                budget_name: res.data.budget
            })
        })
        if (this.validator.allValid()) {
            this.openModal();
        } else {
            this.validator.showMessages();
            document.getElementById("req_post").disabled = false;
        }
    }


    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;

        /* For mobile responsive */

        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div>
                        {/* ProductConfirmation modal */}
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "100%", height: "375px" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }} className="card" style={{ border: '0px solid', fontSize: '13px' }}>
                                    <form>
                                        <div style={{ width: "100%", color: "#008dc7", fontSize: "20px" }}>リクエスト内容確認</div>
                                        {/* <div className="col-md-12"><br /></div> */}
                                        <div className="row" style={{ padding: '6px', display: "none" }}>
                                            <div className="col-md-4">
                                                カテゴリー :
                                            </div>
                                            <div className="col-md-8">
                                                <span>{this.state.cat_name}</span>
                                            </div>
                                        </div>
                                        <div className="row" style={{ padding: '6px', display: "none"  }}>
                                            <div className="col-md-4">
                                                小カテゴリー :
                                            </div>
                                            <div className="col-md-8">
                                                <span>{this.state.sub_cat_name}</span>
                                            </div>
                                        </div>
                                        <div className="row" style={{ padding: '6px' }}>
                                            <div className="col-md-4">
                                                タイトル :
                                            </div>
                                            <div className="col-md-8">
                                                <span>{this.state.title}</span>
                                            </div>
                                        </div>
                                        <div className="row" style={{ padding: '6px' }}>
                                            <div className="col-md-4">
                                                リクエスト内容 :
                                            </div>
                                            <div className="col-md-8">
                                                <span>
                                                    {/* {this.state.description} */}
                                                    {(() => {
                                                        if (this.state.description !== null) {
                                                            return (
                                                                this.state.description.split('\n').map((item, key) =>
                                                                    <span key={key}>
                                                                        {item}
                                                                        <br />
                                                                    </span>
                                                                )
                                                            )
                                                        } else {
                                                            return (
                                                                <div className=""></div>
                                                            )
                                                        }
                                                    })()}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row" style={{ padding: '6px' }}>
                                            <div className="col-md-4">
                                                募集期限 :
                                            </div>
                                            <div className="col-md-8">
                                                <span>{this.state.date}</span>
                                            </div>
                                        </div>
                                        <div className="row" style={{ padding: '6px' }}>
                                            <div className="col-md-4">
                                                予算目安 :
                                            </div>
                                            <div className="col-md-8">
                                                <span>{this.state.budget_name}</span>
                                            </div>
                                        </div>
                                        <div><br /></div>
                                        {/* <div>&nbsp;</div> */}
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>修正する</button>&nbsp;
                                        <button onClick={this.post} id="final_post" style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>
                                                送信する
                                        </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-2">
                            </div>
                            <div className="col-md-8">
                                <div className="">
                                    <div className="mb-3" style={{ textAlign: "left", fontSize: "20px", borderBottom: "1px solid #ccd0c9" }}>
                                        <b>リクエストを入力</b>
                                    </div>
                                    <form onSubmit={this.handleSubmit.bind(this)}>
                                        <div className="form-group"style={{ marginBottom: '10px' }}>
                                            <label htmlFor="email" style={{ marginBottom: '0rem', display: "none"  }}><span className="request_fonts mr-4"><b>カテゴリー</b></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                                            <div className="row" style={{display: "none" }}>
                                                <div className="col-md-7">
                                                    <select className="catagory_select" ref="category" onChange={this.handleChange.bind(this)}  >
                                                        <option value="">選択してください</option>
                                                        {this.state.categories.map(cat =>
                                                            <option value={cat.id} key={cat.id} >
                                                                {cat.cat_name}
                                                            </option>
                                                        )}
                                                    </select>
                                                    <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message('カテゴリー', this.state.category, 'required')}</span>
                                                </div>
                                                <div className="col-md-4 " style={{ marginTop: '10px' }}>
                                                    <label htmlFor="email" style={{ marginBottom: '0rem' }}><span className="request_fonts mt-2 desktop_categories_between_icon"><b>サブカテゴリー</b></span><span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                                                    <select className="catagory_select" ref="subCategory" onChange={this.handleChangesubcat.bind(this)}>
                                                        <option value="">選択してください</option>
                                                        {this.state.subCategories.map(rp =>
                                                            <option value={rp.id} key={rp.id}>
                                                                {rp.cat_name}
                                                            </option>
                                                        )}
                                                    </select>
                                                    <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message('サブカテゴリー', this.state.subCategory, 'required')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: '10px' }}>
                                            <label htmlFor="pwd" style={{ marginBottom: '0rem' }}><span className="request_fonts mr-5"><b>タイトル</b>&nbsp;&nbsp;&nbsp;</span><span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                                            <input style={{ padding: "2%" }} type="text" className="catagory_select" id="title" placeholder="リクエストをしたい内容のタイトルを入力してください" value={this.state.title} onChange={this.updateValue.bind(this, 'title')} />
                                            <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message('タイトル', this.state.title, 'required')}</span>
                                        </div>
                                        <div className="form-group" style={{ marginBottom: '10px' }}>
                                            <label htmlFor="pwd" style={{ marginBottom: '0rem' }}><span className="request_fonts mr-4"><b>リクエスト内容</b></span><span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                                            <textarea className="form-control " row="6" id="descrition" placeholder="リクエスト・お願いしたい内容を詳しく入力してください.." value={this.state.description} onChange={this.updateValue.bind(this, 'description')} ></textarea>
                                            <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message('相談内容', this.state.description, 'required')}</span>
                                        </div>
                                        <div>
                                            <div className="row mb-3">
                                                <div className="col-md-4">
                                                    <span><b>募集期限</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*必須</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <input type="date" className="catagory_select" id="date" placeholder="Date" value={this.state.date} onChange={this.updateValue.bind(this, 'date')} />
                                                    <span style={{ color: "red", fontSize: "12px" }}>
                                                        {this.validator.message('募集期限', this.state.date, 'required')}
                                                    </span>
                                                </div>
                                                <div className="col-md-2"></div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-4">
                                                    <span><b>予算目安</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*必須</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <select
                                                        className="catagory_select"
                                                        onChange={this.updateChange.bind(this)}
                                                        value={this.state.budgetValue}
                                                        style={{ height: "40px" }}
                                                        ref="budget"
                                                    >
                                                        <option value=''>選択してください</option>
                                                        {this.state.budget.map(rp =>
                                                            <option value={rp.id} key={rp.budget_range}>
                                                                {rp.budget_range}
                                                            </option>
                                                        )}
                                                    </select>
                                                    <span style={{ color: "red", fontSize: "12px" }}>
                                                        {this.validator.message('予算目安', this.state.budgets, 'required')}
                                                    </span>
                                                </div>
                                                <div className="col-md-2"></div>
                                            </div>
                                            <div className="button_div">
                                                <button type="submit" id="req_post" className="agree_button" style={{ width: '100%' }}>リクエスト内容を確認する</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                /* For Desktop responsive */
                <div>
                    <Header />
                    <div>
                        {/* ProductConfirmation modal */}
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "375px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }} className="card" style={{ border: '0px solid' }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "25%", color: "#008dc7", fontSize: "20px" }}>リクエスト内容確認</legend>
                                            <div className="col-md-12"><br /></div>
                                            <div className="col-md-12 row" style={{display: "none" }}>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>カテゴリー</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.cat_name}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row" style={{display: "none" }}>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>小カテゴリー</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.sub_cat_name}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>タイトル</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.title}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>リクエスト内容</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.description}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>募集期限</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.date}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>予算目安</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.budget_name}</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div><br /></div>
                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>修正する</button>&nbsp;
                                        <button onClick={this.post} id="final_post" style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>
                                                送信する
                                        </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-2">
                                    </div>
                                    <div className="col-md-8">
                                        <div className="">
                                            <div className="ml-5 mr-5" style={{ textAlign: "left", fontSize: "24px", borderBottom: "1px solid #ccd0c9" }}>
                                                <b>リクエストを入力</b>
                                            </div>
                                            <div className="mini_padding">
                                                <div className="mini_padding inner-div">
                                                    <div className="container">
                                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                                            <div className="form-group">
                                                                <label htmlFor="email" style={{display: "none" }}><span className="request_fonts mr-4"><b>カテゴリー</b></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                                                                <div className="row" style={{display: "none" }}>
                                                                    <div className="col-md-7">
                                                                        <select className="catagory_select" ref="category" onChange={this.handleChange.bind(this)}  >
                                                                            <option value="">選択してください</option>
                                                                            {this.state.categories.map(cat =>
                                                                                <option value={cat.id} key={cat.id} >
                                                                                    {cat.cat_name}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message('カテゴリー', this.state.category, 'required')}</span>
                                                                    </div>
                                                                    <div className="col-md-1">
                                                                        <i className="fa fa-angle-right"></i>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <select className="catagory_select" ref="subCategory" onChange={this.handleChangesubcat.bind(this)}>
                                                                            <option value="">選択してください</option>
                                                                            {this.state.subCategories.map(rp =>
                                                                                <option value={rp.id} key={rp.id}>
                                                                                    {rp.cat_name}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message('サブカテゴリー', this.state.subCategory, 'required')}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-5"><b>タイトル</b>&nbsp;&nbsp;&nbsp;</span><span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                                                                <input style={{ padding: "2%" }} type="text" className="catagory_select" id="title" placeholder="リクエストをしたい内容のタイトルを入力してください" value={this.state.title} onChange={this.updateValue.bind(this, 'title')} />
                                                                <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message('タイトル', this.state.title, 'required')}</span>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>リクエスト内容</b></span><span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                                                                <textarea className="form-control " row="6" id="descrition" placeholder="リクエスト・お願いしたい内容を詳しく入力してください.." value={this.state.description} onChange={this.updateValue.bind(this, 'description')} ></textarea>
                                                                <span style={{ color: "red", fontSize: "12px" }}>{this.validator.message('相談内容', this.state.description, 'required')}</span>
                                                            </div>
                                                            <div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-4">
                                                                        <span><b>募集期限</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*必須</span>
                                                                    </div>
                                                                    <div className="col-md-8">
                                                                        <input type="date" className="catagory_select" id="date" placeholder="Date" value={this.state.date} onChange={this.updateValue.bind(this, 'date')} />
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message('募集期限', this.state.date, 'required')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-2"></div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-md-4">
                                                                        <span><b>予算目安</b></span><span style={{ color: "red", fontSize: "11px", marginLeft: '62px' }}>*必須</span>
                                                                    </div>
                                                                    <div className="col-md-8">
                                                                        <select
                                                                            className="catagory_select"
                                                                            onChange={this.updateChange.bind(this)}
                                                                            value={this.state.budgetValue}
                                                                            style={{ height: "40px" }}
                                                                            ref="budget"
                                                                        >
                                                                            <option value=''>選択してください</option>
                                                                            {this.state.budget.map(rp =>
                                                                                <option value={rp.id} key={rp.budget_range}>
                                                                                    {rp.budget_range}
                                                                                </option>
                                                                            )}
                                                                        </select>
                                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                                            {this.validator.message('予算目安', this.state.budgets, 'required')}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-2"></div>
                                                                </div>
                                                                <div className="button_div">
                                                                    <button type="submit" id="req_post" className="agree_button" >リクエスト内容を確認する</button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    buyerRequest: state.buyerRequest,
    errors: state.errors,
});
PostRequestBuyer = connect(mapStateToProps, { buyerRequest })(withRouter(PostRequestBuyer));
export { PostRequestBuyer }